/*** IMPORTS FROM imports-loader ***/
var define = false;

var parent = require('../../es/object/define-property');

module.exports = parent;

